const basePrefix = import.meta.env.VITE_APP_NAME;
// 企业基本菜单
const router = [
    {
        path: `${basePrefix}/qualification`,
        // redirect: `${basePrefix}/home`,
        meta: {
            title: '商家管理'
        },
        children: [
            // {
            //     path: 'category-qualification',
            //     name: 'categoryQualification',
            //     component: () => import(/* webpackChunkName: "categoryQualificationFormWrap" */ '@/qualification/qualifications/categoryQualificationFormWrap'),
            //     meta: {
            //         title: '类目资质',
            //         isHiddenMenu: true
            //     }
            // },
            {
                path: 'category-qualification-personal',
                name: 'categoryQualificationPersonal',
                component: () =>
                    import(
                        /* webpackChunkName: "categoryQualificationPersonal" */ '@/qualification/qualifications/components/categoryQualificationPersonal'
                    ),
                meta: {
                    title: '类目资质',
                    isHiddenMenu: true
                }
            },
            {
                path: 'goods-qualification',
                name: 'goodsQualification',
                component: () =>
                    import(/* webpackChunkName: "merchantEnter" */ '@/qualification/qualifications/goodsQualification'),
                meta: {
                    title: '商品资质',
                    isHiddenMenu: true
                }
            }
        ]
    }
];

export default router;
